<!-- Trigger -->
<button
  type="button"
  class="flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-2 py-1 transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-300"
  (click)="toggle()"
>
  <span class="rounded-full px-3 py-1 text-sm font-bold text-white" [class]="selected()?.colorClass">
    {{ selected()?.label ?? status() }}
  </span>
  <app-icon
    name="chevron"
    class="h-5 w-5 text-gray-500 transition-transform"
    [class.rotate-180]="open()"
  />
</button>

<!-- Panel -->
@if (open()) {
  <ul
    class="absolute left-0 z-20 mt-2 w-64 overflow-hidden rounded-xl border border-gray-100 bg-white p-1 shadow-lg"
    role="listbox"
  >
    @for (opt of options; track opt.value) {
      <li
        class="flex cursor-pointer items-center justify-between gap-2 rounded-lg px-2 py-2 hover:bg-gray-50"
        role="option"
        [attr.aria-selected]="opt.value === status()"
        (click)="select(opt.value)"
      >
        <span class="rounded-full px-3 py-1 text-sm font-bold text-white" [class]="opt.colorClass">
          {{ opt.label }}
        </span>
        @if (opt.value === status()) {
          <app-icon name="check" class="h-5 w-5 text-gray-700" />
        }
      </li>
    }
  </ul>
}

<!-- Destructive-change confirmation modal -->
@if (pendingStatus()) {
  <app-confirm-dialog (confirmed)="confirm()" (cancelled)="cancel()">
    <ng-container dialogTitle>
      Change status to
      <span class="rounded-full px-3 py-1 text-base font-bold text-white" [class]="pendingOption()?.colorClass">
        {{ pendingOption()?.label }}
      </span>?
    </ng-container>
    The order's photos will be <span class="font-semibold text-red-600">permanently deleted</span>.
    This action cannot be undone.
  </app-confirm-dialog>
}
